module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thank you, Bonnie, for standing by my side since May 22, 1993. You are God’s biggest blessing in my life. I am forever grateful you said “yes.” You model well the lessons included in this book. You are no stranger to pain; yet, because of your great love for Jesus, you have no problem "), _c('span', {
    staticClass: "aitalic"
  }, [_vm._v("Finding Hope in Hardship")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ryleigh Watson, thank you for serving as my editor. You have a sharp eye, a keen sense for excellence, and a big heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("David Hancock, you and the team at Morgan James Publishing are a true blessing. Thank you for believing in me as an author and for being the best publisher and the best publishing company, I know.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 72
// module chunks = 0